import { StyleSheet, View } from 'react-native';

import { Button, Pill, Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type StarterCard = {
  kind: string;
  duration: string;
  start: string;
  price: string;
  cta: string;
};

export function StarterCards({ cards }: { cards: StarterCard[] }) {
  const theme = useTheme();
  return (
    <View style={styles.row}>
      {cards.map((c, i) => (
        <View
          key={c.kind + i}
          style={[
            styles.card,
            {
              backgroundColor: theme.colors.bg,
              borderColor: theme.colors.rule,
              borderRadius: theme.radii.md,
            },
          ]}
        >
          <View style={styles.head}>
            <Pill variant="wine">{c.kind}</Pill>
            <Text variant="h3" style={{ marginTop: 16 }}>
              {c.start}
            </Text>
            <Text variant="meta" tone="fgMute" style={{ marginTop: 6 }}>
              {c.duration}
            </Text>
          </View>
          <View style={[styles.foot, { borderTopColor: theme.colors.rule }]}>
            <Text variant="h4" italic style={{ fontStyle: 'italic', fontFamily: theme.fontFamily.displayItalic, fontSize: 28 }}>
              {c.price}
            </Text>
            <Button variant="primary" size="md" trailingArrow>
              {c.cta}
            </Button>
          </View>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 24,
  },
  card: {
    flex: 1,
    minWidth: 320,
    borderWidth: 1,
    padding: 24,
  },
  head: {
    minHeight: 120,
  },
  foot: {
    marginTop: 24,
    paddingTop: 20,
    borderTopWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    flexWrap: 'wrap',
  },
});
